import type RtpState from './RtpState';

const getRtpState = (rtp: number, rtpLive: number): RtpState => {
  if (rtp > rtpLive) {
    return 'cold';
  }
  if (rtp < rtpLive) {
    return 'hot';
  }
  return 'neutral';
};

export default getRtpState;
